export default function formatPercent(value: number) {
  try {
    if (!value) return '0%';

    const roundedValue = Math.round(Number(value) * 100 * 100) / 100;
    return `${roundedValue}%`;
  } catch (error) {
    return '0%';
  }
}

const formatAprTwoDecimals = (apr: number) =>
  ((Math.abs(apr) * 10000) / 100).toFixed(2);
export const formatApr = (apr: number) =>
  `${formatAprTwoDecimals(apr).toString()}%`;
